/*到款合并 */
import { $http, buildHeaders } from "./index";

//获取列表
export const bankreceivedmerge_list = (params) => {
  return $http.get("/admin/BankReceivedMerge/index", {
    params,
  });
};

//获取客户详情
export const bankreceivedmerge_detail = (id) => {
  return $http.get("/admin/BankReceivedMerge/read?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//审核
export const bankreceivedmerge_check = (data) => {
  return $http.post("/admin/BankReceivedMerge/check", data, {
    headers: buildHeaders(3),
  });
};
